<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/fornecedor">Cadastro/Fornecedores</router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="12">
            <v-text-field
              label="Fornecedor *"
              v-model="nome"
              v-uppercase
              :counter="200"
              maxlength="200"
              :rules="[(v) => !!v || 'O Fornecedor é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="8">
            <v-text-field
              label="Nome Fantasia *"
              v-model="nomeFantasia"
              v-uppercase
              :counter="200"
              maxlength="200"
              :rules="[(v) => !!v || 'O Nome Fantasia é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field label="Produto" value="N/A" readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-text-field
              label="CNPJ/CPF *"
              v-model="cpf_cnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              :counter="18"
              maxlength="18"
              :rules="[
                (v) => !!v || 'O CPF/CNPJ é obrigatório',
                (v) =>
                  (v && this.validaCpfCnpj(v)) || 'O CPF/CNPJ deve ser válido',
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="IE *"
              v-model="inscricaoEstadual"
              :counter="100"
              maxlength="100"
              :rules="[(v) => !!v || 'A Inscrição Estadual é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Contato *"
              v-model="contato"
              v-uppercase
              :counter="100"
              maxlength="100"
              :rules="[(v) => !!v || 'O Contato é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="3">
            <v-text-field
              label="Celular *"
              v-model="celular"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              maxlength="15"
              :rules="[(v) => !!v || 'O Celular é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Telefone"
              v-model="telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              maxlength="15"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-text-field
              label="Ramal"
              v-model="ramal"
              :counter="15"
              maxlength="15"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="9">
            <emails-field ref="emailsField" v-model="emails" />
          </v-col>
        </v-row>
        <endereco ref="endereco" :uppercase="true" />
      </v-form>
      <v-row align="center">
        <v-col class="text-right">
          <slot name="actions">
            <v-btn @click="cancelar" color="error" class="mr-4"> Voltar </v-btn>
            <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
          </slot>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarFornecedorAsync } from "../../../services/fornecedorService";
import { mapActions } from "vuex";
import Endereco from "../Endereco";
import EmailsField from "./EmailsField";

export default {
  name: "criarFornecedor",
  data: () => ({
    overlay: false,
    nome: null,
    nomeFantasia: null,
    cpf_cnpj: null,
    inscricaoEstadual: null,
    contato: null,
    celular: null,
    telefone: null,
    ramal: null,
    emails: [],
  }),
  methods: {
    ...mapActions("fornecedor", ["atualizarFornecedores"]),
    async enviar() {
      const emailsValidos = this.$refs.emailsField.commitPendingEmail();
      var enderecoValido = this.$refs.endereco.updateObjectEstate();
      if (emailsValidos && this.$refs.form.validate() && enderecoValido) {
        this.overlay = true;
        try {
          const resposta = await enviarFornecedorAsync(
            this.nome,
            this.nomeFantasia,
            this.cpf_cnpj,
            this.inscricaoEstadual,
            this.contato,
            this.celular,
            this.telefone,
            this.ramal,
            this.emails.map((email) => ({
              id: 0,
              idFornecedor: 0,
              email,
              ativo: true,
            })),
            this.$refs.endereco.cep,
            this.$refs.endereco.logradouro,
            this.$refs.endereco.numero,
            this.$refs.endereco.complemento,
            this.$refs.endereco.bairro,
            this.$refs.endereco.cidade,
            this.$refs.endereco.uf
          );
          if (!resposta || resposta?.status != 200) {
            this.$alert(
              resposta.message || "",
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            await this.atualizarFornecedores(true);
            this.$store.dispatch("ui/showSnackbar", {
              text: "Salvo com sucesso!",
              color: "success",
              timeout: 3000,
            });
            if (this.onCancelar) {
              this.onCancelar();
            } else {
              this.$router.push("/fornecedor");
            }
          }
        } finally {
          this.overlay = false;
        }
      }
    },
    cancelar() {
      if (this.onCancelar) {
        this.onCancelar();
      } else {
        this.$router.push("/fornecedor");
      }
    },
    mountObjFornecedor(newfor) {
      var fornecedor = new Object();
      fornecedor.id = newfor.id;
      fornecedor.nome = newfor.nome;
      fornecedor.nomeFantasia = newfor.nomeFantasia;
      fornecedor.cpf_cnpj = newfor.cpf_cnpj;
      fornecedor.inscricaoEstadual = newfor.inscricaoEstadual;
      fornecedor.contato = newfor.contato;
      fornecedor.celular = newfor.celular;
      fornecedor.telefone = newfor.telefone;
      fornecedor.emails =
        newfor.emails ||
        this.emails.map((email) => ({
          id: 0,
          idFornecedor: newfor.id,
          email,
          ativo: true,
        }));
      fornecedor.email = newfor.email;
      fornecedor.cep = newfor.cep;
      fornecedor.logradouro = newfor.logradouro;
      fornecedor.numero = newfor.numero;
      fornecedor.complemento = newfor.complemento;
      fornecedor.bairro = newfor.bairro;
      fornecedor.cidade = newfor.cidade;
      fornecedor.uf = newfor.uf;
      fornecedor.ativo = newfor.ativo;
      return fornecedor;
    },
    validaCpfCnpj(val) {
      if (val.length == 14) {
        let cpf = val.trim();

        cpf = cpf.replace(/\./g, "");
        cpf = cpf.replace("-", "");
        cpf = cpf.split("");

        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cpf.length > i; i++) {
          if (cpf[i - 1] != cpf[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (let i = 0, p = 10; cpf.length - 2 > i; i++, p--) {
          v1 += cpf[i] * p;
        }

        v1 = (v1 * 10) % 11;

        if (v1 == 10) {
          v1 = 0;
        }

        if (v1 != cpf[9]) {
          return false;
        }

        for (let i = 0, p = 11; cpf.length - 1 > i; i++, p--) {
          v2 += cpf[i] * p;
        }

        v2 = (v2 * 10) % 11;

        if (v2 == 10) {
          v2 = 0;
        }

        if (v2 != cpf[10]) {
          return false;
        } else {
          return true;
        }
      } else if (val.length == 18) {
        let cnpj = val.trim();

        cnpj = cnpj.replace(/\./g, "");
        cnpj = cnpj.replace("-", "");
        cnpj = cnpj.replace("/", "");
        cnpj = cnpj.split("");

        let v1 = 0;
        let v2 = 0;
        let aux = false;

        for (let i = 1; cnpj.length > i; i++) {
          if (cnpj[i - 1] != cnpj[i]) {
            aux = true;
          }
        }

        if (aux == false) {
          return false;
        }

        for (let i = 0, p1 = 5, p2 = 13; cnpj.length - 2 > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v1 += cnpj[i] * p1;
          } else {
            v1 += cnpj[i] * p2;
          }
        }

        v1 = v1 % 11;

        if (v1 < 2) {
          v1 = 0;
        } else {
          v1 = 11 - v1;
        }

        if (v1 != cnpj[12]) {
          return false;
        }

        for (let i = 0, p1 = 6, p2 = 14; cnpj.length - 1 > i; i++, p1--, p2--) {
          if (p1 >= 2) {
            v2 += cnpj[i] * p1;
          } else {
            v2 += cnpj[i] * p2;
          }
        }

        v2 = v2 % 11;

        if (v2 < 2) {
          v2 = 0;
        } else {
          v2 = 11 - v2;
        }

        if (v2 != cnpj[13]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
  },
  props: {
    onCancelar: { type: Function, default: null },
  },
  components: {
    Endereco,
    EmailsField,
  },
};
</script>
